const Checkbox = (props) => {
  const { name, validation, captionFalse, renderFunc, setValue, register, handleSubmit, watch, control, className, margin, error, label, ...rest } = props
  return (
    <div className={"form-group " + margin}>
      <div className="form-check">
        <input {...register(name, validation)} type="checkbox" className={`form-check-input ${error ? "is-invalid" : ""} ${className}`} {...rest} />
        {label && <label>{label}</label>}

      </div>
      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

Checkbox.defaultProps = {
  register: () => { },
  name: "",
  validation: {},
  className: "",
  error: "",
  label: "",
  margin: "mb-3"
}

export default Checkbox;